import React, { FC } from 'react';

import { TeamDisplay, TeamDisplayContainer } from '@nhl/nhl-react-ui/lib/TeamDisplay';

import { useFranchisesQuery } from '../../../redux/ducks/franchises';
import { FranchisePages } from '../../../redux/ducks/franchises/viewTypes';

import './styles.scss';

type Props = {
    team: any;
    teamDisplay: TeamDisplay;
    franchisePage?: FranchisePages | boolean;
    props?: any;
};

/**
 * This is seperated from the Team Display Module b/c this uses the Franchises Hook, and the Franchise Page header
 * has it's own redux provider, so the useFranchiseHook here won't always work. So if we render this only when
 * franchisePage is passed in, our redux state will be as expected.
 */
const FranchiseDisplay: FC<Props> = ({ team, teamDisplay, franchisePage, ...props }: Props) => {
    const { data: franchises = [] } = useFranchisesQuery({});
    if (franchisePage) {
        // Find the franchises triCode
        const teamId = team.teamId || team.id;
        const franchise = franchises && franchises.find(({ teams }) => teams.find((t) => t.id === teamId));
        if (!franchise) {
            return teamDisplay;
        }

        const triCode = franchise.teamAbbrev.toLowerCase();
        const path = `/${triCode}/overview/${franchisePage}`;
        return (
            <TeamDisplayContainer team={team} {...props}>
                <a className="team-display-link" href={path} target="_blank">
                    {teamDisplay}
                </a>
            </TeamDisplayContainer>
        );
    }
    return teamDisplay;
};

export default FranchiseDisplay;
